import React from "react";
import Icon, { ICON_MAP, ICONS } from "../Core/Icons";
import UserMenu from "./UserMenu";
import { Link } from "react-router";
import { useHasScrolled } from "@/hooks/useHasScrolled";
import { cn } from "@/lib/utils";

const AppHeaderAlt = React.memo(() => {
  const { hasScrolled, ref } = useHasScrolled();

  return (
    <nav
      className={cn(
        " shrink-0 flex items-center justify-between z-2002 h-11 transition-all duration-200 ease-out  border-b",
        hasScrolled ? "bg-background p-2" : "px-4 pt-4 border-b-transparent",
      )}
      ref={ref}
    >
      <div className="flex-row flex grow justify-between items-center ml-0 my-0">
        <Link
          to="/"
          className="cursor-pointer flex items-center gap-1"
          aria-label="Home"
        >
          <svg
            width="78"
            height="20"
            viewBox="0 0 78 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM15.0857 5.95238L16 4.66667H4L4.91442 5.95238H9.30676L9.29716 16.2729L9.95013 17.13L10.6031 16.2729L10.6127 5.95238H15.0857ZM7.77398 14.0952L8.86227 15.381V6.38095H5.21931L5.98137 7.45238L7.77863 7.45238L7.77398 14.0952ZM11.0388 15.381L12.1229 14.0952V7.45238H14.0189L14.7809 6.38095H11.0388V15.381Z"
              fill="#F5F5F6"
            />
            <path
              d="M28.9984 15.8V5.8944H25.3248V4.32H34.394V5.8944H30.7204V15.8H28.9984Z"
              fill="#F5F5F6"
            />
            <path
              d="M38.2247 15.9476C35.6335 15.9476 33.9443 14.0452 33.9443 11.5852C33.9443 9.0924 35.6499 7.2064 38.2083 7.2064C40.6847 7.2064 42.2427 9.158 42.2427 11.3884V12.1592H35.6007C35.8139 13.7664 36.8963 14.4716 38.2247 14.4716C39.5695 14.4716 40.4387 13.6516 40.7011 12.9136L41.9639 13.586C41.6031 14.5208 40.4551 15.9476 38.2247 15.9476ZM35.6499 10.7816H40.5371C40.5207 9.732 39.6351 8.6496 38.1919 8.6496C36.9455 8.6496 35.9287 9.3876 35.6499 10.7816Z"
              fill="#F5F5F6"
            />
            <path
              d="M43.9637 15.8V7.354H45.6037V8.42C45.9973 7.682 46.8829 7.2064 47.8997 7.2064C49.0313 7.2064 49.9497 7.7312 50.5073 8.5184C50.9337 7.9608 51.7701 7.2064 53.2133 7.2064C55.1649 7.2064 56.5425 8.6168 56.5425 10.388V15.8H54.9025V10.7816C54.9025 9.5188 54.0989 8.748 53.0001 8.748C51.8685 8.748 51.0649 9.5844 51.0649 10.7816V15.8H49.4249V10.7816C49.4249 9.5188 48.6377 8.748 47.5225 8.748C46.3909 8.748 45.6037 9.5844 45.6037 10.7816V15.8H43.9637Z"
              fill="#F5F5F6"
            />
            <path
              d="M58.5065 19.5556V7.354H60.1465V8.4364C60.6877 7.7148 61.7045 7.2064 62.9673 7.2064C65.2633 7.2064 67.0837 8.8464 67.0837 11.5852C67.0837 14.1272 65.2961 15.9476 62.9673 15.9476C61.7045 15.9476 60.6385 15.4064 60.1465 14.6848V19.5556H58.5065ZM60.1137 11.5852C60.1137 13.1268 61.1305 14.4224 62.7705 14.4224C64.4105 14.4224 65.4273 13.1432 65.4273 11.5852C65.4273 10.0108 64.4105 8.7316 62.7705 8.7316C61.1305 8.7316 60.1137 10.0272 60.1137 11.5852Z"
              fill="#F5F5F6"
            />
            <path
              d="M72.8473 15.9476C70.2561 15.9476 68.4029 14.1108 68.4029 11.5852C68.4029 9.0596 70.2725 7.2064 72.8473 7.2064C75.4221 7.2064 77.2917 9.0596 77.2917 11.5852C77.2917 14.0944 75.4385 15.9476 72.8473 15.9476ZM70.0593 11.5852C70.0593 13.258 71.2893 14.4388 72.8473 14.4388C74.4217 14.4388 75.6353 13.258 75.6353 11.5852C75.6353 9.9124 74.4217 8.7316 72.8473 8.7316C71.2729 8.7316 70.0593 9.9124 70.0593 11.5852Z"
              fill="#F5F5F6"
            />
          </svg>
        </Link>
        <div className="grow" />
        <UserMenu />
      </div>
    </nav>
  );
});

export default AppHeaderAlt;
